<template>
  <div v-if="visible" class="popup">
    <div style="width: 1000px;height: 80%;overflow: auto;">
      <!-- 弹窗的内容 -->
      <div class="popup-content">
        <div align="center">
          <div style="width: 100%;height: 30px;">
            <h1 style="display: flex;align-items: center;justify-content: center;">
              <div class="gradient-line"></div>
              <span style="color: #BB1800;font-size: 17pt;">举报须知</span>
              <div class="gradient-line-right"></div>
            </h1>
          </div>
        </div>
        <div style="margin-left: 15px;margin-right: 15px;margin-top: 10px">
          <ol style="font-size: 15pt;">
            <li align="left" style="margin-bottom:5px;margin-top: 10px;text-align: left;">
              <span style=" font-size: 15pt;line-height: 40px;">本举报网站主要受理反映利津县各级领导班子和领导干部违反干部选拔任用工作政策法规选人用人，以及领导干部政治、思想、作风、廉洁自律等方面问题的举报。</span>
            </li>

<!--            <li align="left" style="margin-bottom:5px;text-align: left;">
              <span style="font-size: 15pt;line-height: 40px;">如果您要反映违反党的纪律问题、个人信访问题、涉法涉诉问题、土地征用、房屋拆迁及房产纠纷问题、土地、山林、水利权属纠纷问题、劳动用工维权等问题，请点击“其他举报方式”进入相关页面处理。</span>
            </li>-->
            <li align="left" style="margin-bottom:5px;text-align: left;">
              <span style="font-size: 15pt;line-height: 40px;">请认真填写举报表单中的各项目。填写“主要问题”一项时，要写清楚问题发生的时间、地点、涉及人员、情节、后果等，字数一般限定在800字。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
              <span style="font-size: 15pt;line-height: 40px;">举报人应实事求是地反映问题。对利用举报捏造事实，进行诬告陷害的，依照有关规定严肃处理；构成犯罪的，移交司法机关处理。</span>
            </li>
            <li align="left" style="margin-bottom:1px;text-align: left;">
              <span
                  style="font-size: 15pt;line-height: 40px;">提倡实名举报。进行实名举报时，请详细填写联系电话等项目。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
              <span
                  style="font-size: 15pt;line-height: 40px;">为保障举报人的合法权益，限制恶意重复举报和垃圾信件，提高网上举报的运行效率，举报人计算机每天最多只能提交5件举报。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
							<span style="font-size: 15pt;line-height: 40px;">网上举报只是反映问题的一种途径，还可通过信件或电话、短信等形式进行举报。<br/>
							通讯地址：东营市利津县利一路121号组宣党史综合楼308室，邮政编码：257400<br/>
							联系电话：0546-5612380<br/>
							短信举报号码：15154612380（仅接收短信）。<br/>
							</span>
            </li>
          </ol>

          <div align="center">
            <div style="width: 100%;height: 30px;">
              <h1 style="display: flex;align-items: center;justify-content: center;">
                <div class="gradient-line"></div>
                <span style="color: #BB1800;font-size: 17pt;">其他举报方式</span>
                <div class="gradient-line-right"></div>
              </h1>
            </div>
          </div>
          <ol style="font-size: 15pt;">
            <li align="left" style="margin-bottom:5px;margin-top: 10px;text-align: left;">
                <span style="font-size: 15pt;line-height: 40px;">如果您要反映违反党的纪律问题，请向<a
                    href="http://shandong.12388.gov.cn/dongying/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市纪委监委</a>相关部门进行举报。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映个人信访等问题，请向<a
                    href="http://dyxf.dongying.gov.cn/" target="_blank" style="text-decoration: none; color: blue;">东营市信访局</a>进行举报。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
                <span style="font-size: 15pt;line-height: 40px;">如果您要反映涉法涉诉等问题，请向<a
                    href="http://www.dyjc.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市人民检察院</a>或<a
                    href="http://dyzy.sdcourt.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市中级人民法院</a>进行举报。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映土地征用、房屋拆迁及房产纠纷等问题，请向<a
                    href="http://dyzrzy.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市自然资源和规划局</a>进行举报。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映土地、山林、水利权属纠纷等问题，请向<a
                    href="http://dyzrzy.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市自然资源和规划局</a>或<a
                    href="http://dyny.dongying.gov.cn/"
                    target="_blank"
                    style="text-decoration: none; color: blue;">东营市农业农村局</a>进行举报。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映劳动用工维权等问题，请向<a
                    href="http://dylss.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市人力资源和社会保障局</a>进行举报。</span>
            </li>
          </ol>

          <div align="center">
            <div style="width: 100%;height: 30px;">
              <h1 style="display: flex;align-items: center;justify-content: center;">
                <div class="gradient-line"></div>
                <span style="color: #BB1800;font-size: 17pt;">受理介绍</span>
                <div class="gradient-line-right"></div>
              </h1>
            </div>
          </div>
          <!--            <div style="margin-left: 15px;margin-right: 15px;margin-top: 30px">-->
          <ol style="font-size: 15pt;">
            <li align="left" style="margin-bottom:5px;margin-top: 10px;text-align: left;">
              <span style="font-size: 15pt;line-height: 40px;">本举报网站的受理部门是中共利津县委组织部。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">中共利津县委组织部将本着“态度认真、办理公正、调查及时、处理严肃”的原则，慎重负责地处理网上举报件。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
              <span style="font-size: 15pt;line-height: 40px;">对受理范围内的举报，根据被举报对象的职级和举报反映的问题，依据有关规定，由中共利津县委组织部办理或督促有关地方、部门（单位）组织人事部门及其他相关部门承办。其中，对群众反映的性质严重、内容具体、线索清楚的选人用人问题及其他主要问题，中共利津县委组织部进行立项督查，要求承办单位在规定时限内报告查核处理结果。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">对经查问题属实的，依据有关规定，坚决纠正、严肃问责；严重违反规定、已构成违纪违法的，移交执纪执法机关处理。</span>
            </li>
            <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">为了保护举报人，严格执行保密制度，切实保护举报人的合法权益，对打击报复举报人的行为，严肃追究有关人员的责任。</span>
            </li>
          </ol>

        </div>
        <!-- <div class="btndiv" style="display: flex;justify-content: center;">
            <a  @click="goForm" :disabled="readBtn.disabled" style="cursor: pointer;"><div :style="{width: '200px',height: '40px', backgroundColor: isRead ? '#BB1800' : '#c5c5c5' , display: 'flex', justifyContent: 'center',alignItems: 'center'}"><span style="color: #fff;font-size: large;">{{ readBtn.text }}</span></div> </a >
          </div> -->
        <div>
          <el-radio ref="radio" v-model="radio" label="1" :disabled=!isRead><span style="color:#BB1800 ">我已知晓以上举报须知事项</span></el-radio>
        </div>
        <div class="btndiv" style="display: flex; justify-content: center; align-items: center;">
          <a @click="goForm" :disabled="readBtn.disabled" style="cursor: pointer;">
            <div
                :style="{width: '200px',height: '40px', backgroundColor: isRead ? '#BB1800' : '#c5c5c5' , display: 'flex', justifyContent: 'center',alignItems: 'center'}">
              <span style="color: #fff;font-size: large;">{{ readBtn.text }}</span></div>
          </a> &nbsp;
          <a @click="closePopup" style="cursor: pointer;">
            <div
                style="width: 200px;height: 40px; background-color: #C5C5C5;display: flex;justify-content: center;align-items: center;">
              <span style="color: #fff;font-size: large;">关闭</span></div>
          </a> &nbsp;
          <!-- <a @click="commit()" style="cursor: pointer;"><div style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;"><span style="color: #fff;font-size: large;">提交</span></div> </a> -->
        </div>
      </div>
      <!-- 关闭按钮 -->
      <!-- <button class="close-button" @click="closePopup" style="float: right;">关闭</button> -->
    </div>

  </div>
</template>

<script>
export default {
  name: "POpup",
  data() {
    return {
      readBtn: {
        time: 10,
        disabled: true,
        text: '我已阅读并同意(10秒)'
      },
      isRead: false,
      timer: null,
      radio: undefined
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    }
  },
  created() {
    //this.initRead()

  },
  methods: {
    initStart(t) {
      this.isRead = false;
      this.readBtn.time = t;
      this.initRead();
    },
    initRead() {
      this.radio=null
      if (this.readBtn.time>0) {
        this.readBtn.text = `我要举报(${this.readBtn.time}秒)`
        this.readBtn.time--
        this.timer = setTimeout(() => {
          this.initRead()
        }, 1000)
      } else {
        this.readBtn.disabled = false
        this.readBtn.text = '我要举报'
        this.isRead = true
        clearTimeout(this.timer)
      }
    },
    closePopup() {
      clearTimeout(this.timer);
      this.radio=null
      this.$emit('close');
      //this.$emit('goForm');
    },
    goForm() {
      if (!this.isRead) {
        console.log(this.readBtn.time)
        return
      }
      clearTimeout(this.timer);
      if(this.radio!=1){
        this.$alert('请阅读举报须知说明，然后选中‘我已知晓以上举报须知事项’！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      this.$emit('goForm');
    }
  }
}
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 400px;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
}

.close-button {
  margin-top: 10px;
}

.gradient-line {
  width: 150px; /* 横线的宽度 */
  height: 2px; /* 横线的高度 */
  background: linear-gradient(to right, #fff, #BB1800); /* 渐变效果 */
}

.gradient-line-right {
  width: 150px; /* 横线的宽度 */
  height: 2px; /* 横线的高度 */
  background: linear-gradient(to right, #BB1800, #fff); /* 渐变效果 */
}

.el-radio__input.is-checked + .el-radio__label {
  color: #BB1800 !important;
}
.el-radio__input.is-checked .el-radio__inner {
  background: #BB1800 !important;
  border-color: #BB1800 !important;
}
.el-radio__inner:hover{
  border-color: #BB1800 !important;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: 0 0 2px 2px #BB1800 !important;
}
</style>
